import React from 'react';
import styles from './styles.module.css';
import Button from '@/components/common/Button';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import ToolbarIcons from '@/icons/toolbar';
import AppLink from '@/components/common/AppLink';

export default function NotFoundBox({
  clearButton,
  text,
}: {
  clearButton?: boolean;
  text?: string;
}) {
  const tCommon = useTranslations('common');
  return (
    <div className={`${styles.empty_state} panel`}>
      <ToolbarIcons.SearchIcon fill="var(--text-lo)" width="32px" height="32px" />

      <p>{text ? text : tCommon('noDeviceMatches')}</p>

      {clearButton && (
        <AppLink href="/shop" title={`${tCommon('clearAll')}`}>
          <Button
            className={`btn btn-ghost ${styles.button}`}
            //   onClick={onClear}
          >
            {tCommon('clearAll')}
          </Button>
        </AppLink>
      )}
    </div>
  );
}
